import React, { useContext, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap' ;
import Backdrop  from '@material-ui/core/Backdrop'
import {makeStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import styles from './CreatePageTemplate.module.css'
import CollapsibleComponent from '../../../ReusableComponents/CollapseCard/CollapseCard';
import { sendRequestForPageTemplate } from '../../IFormDesignerLayout/RequestLogic';
// import AppViewer from '../../AppViewer/AppViewer';
import { CircularProgress } from '@material-ui/core';
import { AppContext } from '../../../Resources/CanvasContextFile';
import axios from '../../../axios';
import { useSelector } from "../../../Redux";
import { useTranslation } from 'react-i18next';
import SubformTemplate from './SubformTemplate';
import {sanitizeStringToJson} from "../../../Resources/globalFunctions"
import { GetStateFromData } from '../../CustomHooks/CustomHooks';



const useStyles = makeStyles((theme) => ({
  backdrop: {
    // width: '1047px',
    // height: '394px',
    zIndex: 10000 ,
    color: '#fff',
  },
}));

export default function CreatePageTemplate(props) {
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";      
  const classes = useStyles();
  const AppContextVar = useContext(AppContext);
  const { t } = useTranslation();
  var setFormState ;
  if(AppContextVar!==undefined){
      setFormState = AppContextVar.setFormState;
  }
  const contexts = GetStateFromData();
  const { setSubForms, activeApplication, allSubForms,setSeverity,setSeverityMessage,setOpen1,applyChanges,updateJson, setAlertData } = contexts.contexts;
  const { updatedComponentInFormState} =updateJson;

  const [open, setOpen] = React.useState(props.open);
  const [editingToolOption, setEditingToolOption] = React.useState('Resize Image');
  const [templateDetails, setTemplateDetails] = React.useState('');
  const [showLoader, setShowLoader] = React.useState(false);
  const [templateForm, setTemplateForm] = React.useState({ });
  const [templateType, setTemplateType] = React.useState('System defined');
  const [selectedTemplateOption, setSelectedTemplateOption] = React.useState(undefined);
  const [pageTemplates, setPageTemplates] = useState();
  const [subformTemplates, setSubformTemplates] = useState();
  const [imageFile, setImageFile] = useState();
  const [formBuffer, setFormBuffer] = useState();
  const [select, setSelect] = useState(false);
  const [title, setTitle] = useState("");
  const [homePage, setHomePage] = useState("");

  const [newPageTemplate,setNewPageTemplate]=useState({});
  const [newPage,setNewPage]=useState({
    processDefId:0,
    // formId:"",
    formName:`Page ${props.allPagesCount +1}`,
    formBuffer:JSON.stringify(props.defaultBuffer),
    isEncrypted:"N",
    lastModifiedOn:new Date(),
    deviceType:"A",
    formHeight:400,
    formWidth:400,
    existingFormId:"",
    formType:"P"
  });


  const [newSubForm, setNewSubForm] = useState({
    processDefId: 0,
    // fragmentId:"",
    fragmentName: "",
    //fragmentBuffer:"",
    fragmentBuffer: JSON.stringify(props.defaultBuffer),
    isEncrypted: "N",
    structureName: "",
    structureId: -1,
    lastModifiedOn: new Date(),
    deviceType: "A",
    formHeight: 400,
    formWidth: 400,
    projectId: "",
  });

  useEffect(()=>{
    let payload = { withCredentials: true };
    // http://localhost:8080/iforms/templates/Templatetype/{PAGE/FORM/TEMPLATE}
    if(props.componentFor==='page'){
      axios.get('/templates/Templatetype/PAGE',payload)
      .then((response)=>{  
        // console.log("pageTemp...",response)
        setPageTemplates(response.data)
      })
    .catch((err)=>  console.log(err));
    } else if (props.componentFor === "subform") {
      axios
        .get("/templates/Templatetype/FORM", payload)
        .then((response) => {
          // console.log("pageTemp...",response)
          setSubformTemplates(response.data);
        })
        .catch((err) => console.log(err));
    }
  },[]);
 useEffect(()=>{
  document.getElementById("createPageTemplate")?.focus();
 },[])
  const templateOptions = {
    'Login Page' : [ {'label' : 'Image On Left' ,'src':require('../../../Icons/imageOnLeft.svg'), 'templateFormName' : 'LeftImageTemplateForm'},
                    {'label' : 'Image On Right' ,'src':require('../../../Icons/imageOnRight.svg'), 'templateFormName' : 'RightImageTemplateForm'},
                    {'label' : 'Without Image' ,'src':require('../../../Icons/withoutImage.svg'), 'templateFormName' : 'WithoutImageTemplateForm'},
                    {'label' : 'Background Image' ,'src':require('../../../Icons/BackgroundImage.svg'), 'templateFormName' : 'BackgroundImageTemplateForm'}],
    'Product Selection Page' : [ {'label' : 'Product Selection-Horizontal' ,'src':require('../../../Icons/imageOnLeft.svg')},
                    {'label' : 'Product Selection-Vertical' ,'src':require('../../../Icons/imageOnRight.svg')}],
    'Homepage' : ''
  }


  const pageTemplateOptions = {
    'Page Templates' : pageTemplates,
    'Subform Templates':subformTemplates,
  }
  var collapsibleItems = [];
  var collapsibleItems2 = [];


  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const [isSelected,setIsSelected] = useState(false)
  function handleClickTemplate(prop) {
    setIsSelected(true)
    setShowLoader(true);
    setImageFile(prop.templateimage);
    axios.get(`/templates/${prop.templateid}`,{withCredentials:true})
    .then(res=>{   
      setSelectedTemplateOption(res.data.templatename);
      setFormBuffer(res.data.templatebuffer);
      setSelect(true);
      setShowLoader(false);
    })
    .catch(()=>{
       console.log("ERROR ON getting template formjson", activeApplication.applicationId );
      setSelect(false);
    })  
  }

  function handleTemplate(){

    if(props.setAddNewPageLoader){
      props.setAddNewPageLoader(true);
    }

    let newPageJson={...newPage,"existingFormId": activeApplication.applicationId};
    let dateNow = new Date();
    newPageJson['Createddatetime'] = dateNow;
    newPageJson['Createdby'] = 'Shivam';
    newPageJson['LastAccessedby'] = 'Shivam';
    newPageJson['lastModifiedtime'] = dateNow;
    newPageJson['UsageCount'] = 0;
    newPageJson["lastAccessedtime"] = dateNow;
    newPageJson["projectId"] = activeApplication.applicationId;
    newPageJson["fragmentName"] = title;

    if(select){
      newPageJson={...newPageJson,"formBuffer": formBuffer};
    }
    if(title){
      newPageJson={...newPageJson,"formName": title};
      
    }
    let apiToHit = "/interfaces/";
    let payload = newPageJson;;
    if(props.componentFor==='subform'){
      let newSubformJson = {...newSubForm};
      newSubformJson["Createddatetime"] = dateNow;
      newSubformJson["Createdby"] = "Shivam";
      newSubformJson["LastAccessedby"] = "Shivam";
      newSubformJson["lastModifiedtime"] = dateNow;
      newSubformJson["UsageCount"] = 0;
      newSubformJson["lastAccessedtime"] = dateNow;
      newSubformJson["LastModifiedby"] = "Shivam";
      newSubformJson["projectId"] = activeApplication.applicationId;
      newSubformJson["fragmentName"] = title;
      newSubformJson["fragmentBuffer"] = formBuffer || JSON.stringify(props.defaultBuffer); 

      apiToHit = "/widgets/";
      payload = newSubformJson;
    }
    axios.post(apiToHit,payload,{withCredentials:true})
    .then(res=>{
      // console.log("page...", res);
      if(props.componentFor==='subform'){
        getAllSubForms();
      } else {
        if(homePage){
          props.setPageAsHome(res.data);
        }
        props.getAllPages();
      }
      if(props.componentFor==='subform'){
        let object = {
          artifactType: "Portals",
          id:res.data.fragmentId.toString() ,
          name: res.data.fragmentName
        }
        window.activityStream(object,"201","create","ifd_0004");
        let formBuffer = sanitizeStringToJson(res.data.fragmentBuffer);
        formBuffer.formId = res?.data?.fragmentId;
        // applyChanges(formBuffer ,true)
        // updatedComponentInFormState()
      } else {
        window.activityStream("Username has created interface "+ res.data.formName,201,1,activeApplication.applicationId,res.data.formId);
      }
      props.setAddNewPageLoader(false);
      // props.setCurrentPage(res.data);
    })
    .catch((err)=>{
      const errMessage = err.response.data.error;
      let errorMessage;
      if(errMessage === '502')
        errorMessage = "Widget_Name_Already_Exists";
      else if(errMessage === '501')
        errorMessage = "Widget_Name_Is_Empty";
      else if(errMessage === '402')
        errorMessage = "Page_Name_Already_Exists";
      else if(errMessage === '401')
        errorMessage = "Page_Name_Is_Empty";
      // if(errMessage !== '502'){
      //   setOpen1(true)
      //   setSeverityMessage(() => `${t(errorMessage)}`);
      //   setSeverity(()=>"error")
      // }else{
         setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000,
        });
      // }
       console.log("ERROR ON createing new page with template", activeApplication.applicationId, `${t(errorMessage)}` );
      props.setAddNewPageLoader(false);
    })
    // setOpen(false);
    props.handleClose()
  }

  function createBlankPage() {
    if(props.setAddNewPageLoader){
      props.setAddNewPageLoader(true);
    }
    let newPageJson={...newPage,"existingFormId": activeApplication.applicationId};
    if(title){
      newPageJson={...newPageJson,"formName": title};
    }
    if(homePage){
    let dateNow = new Date();
    newPageJson['Createddatetime'] = dateNow;
    newPageJson['Createdby'] = 'Shubham';
    newPageJson['LastAccessedby'] = 'Shubham';
    newPageJson['lastModifiedtime'] = dateNow;
    newPageJson['UsageCount'] = 0;
    newPageJson["lastAccessedtime"] = dateNow;
    newPageJson["projectId"] = activeApplication.applicationId;
    newPageJson["fragmentName"] = title;

    if(select){
      newPageJson={...newPageJson,"formBuffer": formBuffer};
    }
    if(title){
      newPageJson={...newPageJson,"formName": title};
      
    }
    let apiToHit = "/interfaces/";
    let payload = newPageJson;;

    axios.post(apiToHit,payload,{withCredentials:true})
    .then(res=>{
        props.setPageAsHome(res.data);
        // props.getAllPages();
        props.setAddNewPageLoader(false);
        window.activityStream("Username has created interface "+ res.data.formName,201,-1,activeApplication.applicationId,res.data.formId);
        props.setCurrentPage(res.data);
    }).catch((err)=>{
      const errMessage = err.response.data.error;
      let errorMessage;
      if(errMessage === '502')
        errorMessage = "Widget_Name_Already_Exists";
      else if(errMessage === '501')
        errorMessage = "Widget_Name_Is_Empty";
      else if(errMessage === '402')
        errorMessage = "Page_Name_Already_Exists";
      else if(errMessage === '401')
        errorMessage = "Page_Name_Is_Empty";
      //   if(errMessage !== '502'){
      //   setOpen1(true)  
      //   setSeverityMessage(() => `${t(errorMessage)}`);
      //   setSeverity((prev)=>prev = "error")
      // }else{
         setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000,
        });
      // }
         console.log("ERROR ON adding new pages ", activeApplication.applicationId, `${t(errorMessage)}` );
        props.setAddNewPageLoader(false);
    })
    }else{
      axios.post("/interfaces/",newPageJson,{withCredentials:true})
      .then(res=>{
          // console.log("NO ERROR ON adding new pages ");
          props.getAllPages();
          props.setAddNewPageLoader(false);
          window.activityStream("Username has created interface "+ res.data.formName,201,-1,activeApplication.applicationId,res.data.formId);
          props.setCurrentPage(res.data);
      })
      .catch((err)=>{
        const errMessage = err.response.data.error;
        let errorMessage;
        if(errMessage === '502')
          errorMessage = "Widget_Name_Already_Exists";
        else if(errMessage === '501')
          errorMessage = "Widget_Name_Is_Empty";
        else if(errMessage === '402')
          errorMessage = "Page_Name_Already_Exists";
        else if(errMessage === '401')
          errorMessage = "Page_Name_Is_Empty";
      //   if(errMessage !== '502'){
      //   setOpen1(true)
      //   setSeverityMessage(() => `${t(errorMessage)}`);
      //   setSeverity((prev)=>prev = "error")
      // }else{
         setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000,
        });
      // }
           console.log("ERROR ON adding new pages ", activeApplication.applicationId, `${t(errorMessage)}` );
          props.setAddNewPageLoader(false);
      })
    }
    
    // if(homePage){
    //   props.setPageAsHome(activeApplication?.selectedPage);
    // }
    // props.getAllPages();
    
    // handleClose();
    props.handleClose()
    
  }
  
  function handleEscapeKey(e){
    if(e.code === "Escape"){
      props.handleClose()
    } 
   }

  function getAllSubForms(){
    axios.get(`/widgets/${activeApplication.applicationId}`,{withCredentials:true})
    .then((res)=>{
        setSubForms([...(res.data)]);
    })
    .catch(()=>{
         console.log("ERROR ON LOADING PAGES OF APP ID ", activeApplication.applicationId );
    })
  }

  function addNewSubForm(){     
    const newSubFormJson={...newSubForm,"projectId": activeApplication.applicationId, fragmentName:title};
    axios.post("/widgets/",newSubFormJson,{withCredentials:true})
    .then(res=>{
        getAllSubForms();
        props.setCurrentSubform(res.data);
    })
    .catch((err)=>{
      const errMessage = err.response.data.error;
            
      let errorMessage;
      if(errMessage === '502')
        errorMessage = "Widget_Name_Already_Exists";
      else if(errMessage === '501')
        errorMessage = "Widget_Name_Is_Empty";

      // if(errMessage !== '502'){
        // // setOpen1(true);
        // setSeverityMessage(() => `${t(errorMessage)}`);
        // setSeverity(() => "error");
      // }else{
         setAlertData({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000,
        });
      // }
         console.log("ERROR ON adding new pages ", activeApplication.applicationId );
    })
    props.handleClose();
  }
 

  function handlePageTitle(e){
    if(/^[a-zA-Z\u0621-\u064A][a-zA-Z0-9\u0621-\u064A\s]*$|^$/u.test(e.target.value)) {
      setTitle(e.target.value);
    }
  }
  function handlePageCheckbox(e){
    setHomePage(e.target.checked);
  }

  function handlePageTemplate(templateType, templateSubType, templateFormName){
    // setShowLoader(true);
    var jsonToSend = {'templateName' : templateFormName}; 
    sendRequestForPageTemplate(jsonToSend).then((response)=>{
        // console.log(response);
        if(response.status === 200){
          setTemplateForm(response.data);
          setSelectedTemplateOption(templateSubType);
          // setShowLoader(false);
        }
    })
    
  }
  function x(action,dir){   
    
  }
  if(templateOptions){
    Object.keys(templateOptions).forEach((key, index)=>{
      
      collapsibleItems.push(<CollapsibleComponent id={index+""} 
      heading={key} 
      createPageTemplate
      body={createTemplateOption(key)}
      />);

    })
  }

  if(pageTemplateOptions){
    Object.keys(pageTemplateOptions).forEach((key, index)=>{
      if (props.componentFor === "subform" && key === "Subform Templates") {
        collapsibleItems2.push(
          <CollapsibleComponent
          createPageTemplate
            id={index + ""}
            heading={key}
            body={createPageTemplateOption(key)}
          />
        );
      } else if (props.componentFor === "page" && key === "Page Templates") {
        collapsibleItems2.push(
          <CollapsibleComponent
          createPageTemplate
            id={index + ""}
            heading={key}
            body={createPageTemplateOption(key)}
          />
        );
      }

    })
  }
  
function createTemplateOption(key) {
  switch(key){
    case 'Login Page' :  return(
            <div className={styles.templateOptionDiv}>
              {
              templateOptions[key].map((props)=>{
                return(
                  <Col className={styles.templateOptionParent} style={{ height: "auto"}}>
                    {/* <div className={styles.templateOption +' '+ selectedTemplateOption === props.label ? styles.selectedTemplateOption : null} 
                        onClick={()=> setSelectedTemplateOption(props.label)}> */}
                        <img src={(props.src).default} style={{width:'100%' , height: '100%'}} 
                        onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)} alt='Template Icon'/>
                    {/* </div> */}
                    <span style={{margin:'auto', textAlign:'center'}} 
                    className={selectedTemplateOption === props.label ? styles.definedText + ' ' + styles.selectedTemplateText : styles.definedText} 
                        onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}>
                        {t(props.label)}
                    </span>
                  </Col>
                )
              })}
            </div>
          )
    case 'Product Selection Page' :  return(
      <div className={styles.templateOptionDiv}>
        {
        templateOptions[key].map((props)=>{
          return(
            <Col className={styles.templateOptionParent}>
              {/* <div className={styles.templateOption +' '+ selectedTemplateOption === props.label ? styles.selectedTemplateOption : null} 
                  onClick={()=> setSelectedTemplateOption(props.label)}> */}
                  <img src={(props.src).default} style={{width:'100%' , height: '100%'}} 
                  onClick={()=> handlePageTemplate(key,props.templateFormName)} alt='Template Form'/>
              {/* </div> */}
              <span style={{margin:'auto', textAlign:'center', marginBottom: "10px"}} 
              className={selectedTemplateOption === props.label ? styles.definedText + ' ' + styles.selectedTemplateText : styles.definedText} 
                  onClick={()=> handlePageTemplate(key,props.templateFormName)}>
                  {t(props.label)}
              </span>
            </Col>
          )
        })}
      </div>
    )
    case 'Home Page' : return null;
    default: return null;
  }
   
}


function createPageTemplateOption(key) {
  switch (key) {
    case "Page Templates":
      return (
        <>
          {/* <h1 style={{color:"#000"}}>hello</h1> */}
          {/* {console.log("pageTemp...", pageTemplateOptions)} */}
          <div className={styles.templateOptionDiv}>
            {pageTemplateOptions &&
              pageTemplateOptions[key] &&
              pageTemplateOptions[key].map((props) => {
                return (
                  <Col className={`${styles.templateOptionParent} ${styles.templateOptionParentNew}`} >
                    <div
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.userDefinedTemplate +
                            " " +
                            styles.userDefinedSelectedTemplate
                          : styles.userDefinedTemplate
                      }
                    >
                      <div
                        style={{
                          background: `url(${props.templateimage}) no-repeat`,
                          backgroundSize: "cover",
                          height: "88px",
                          width: "110px",
                        }}
                        onClick={() => handleClickTemplate(props)}
                      ></div>
                    </div>
                    {/* <div style={{background: `url(${props.templateimage}) no-repeat`, height: '114px', width: '92px'}} ></div> */}
                    {/* </div> */}
                    <span
                      style={{ margin: "auto", textAlign: "center" }}
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.definedText +
                            " " +
                            styles.selectedTemplateText
                          : styles.definedText
                      }
                      // onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}
                    >
                      {props.templatename}
                    </span>
                  </Col>
                );
              })}
          </div>
        </>
      );
    case "Subform Templates":
      return (
        <>
          {/* <h1 style={{color:"#000"}}>hello</h1> */}
          {/* {console.log("pageTemp...", pageTemplateOptions)} */}
          <div className={styles.templateOptionDiv}>
            {pageTemplateOptions &&
              pageTemplateOptions[key] &&
              pageTemplateOptions[key].map((props) => {
                return (
                  <Col className={styles.templateOptionParent}>
                    <div
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.userDefinedTemplate +
                            " " +
                            styles.userDefinedSelectedTemplate
                          : styles.userDefinedTemplate
                      }
                    >
                      <div
                        style={{
                          background: `url(${props.templateimage}) no-repeat`,
                          backgroundSize: "cover",
                          height: "88px",
                          width: "110px",
                        }}
                        onClick={() => handleClickTemplate(props)}
                      ></div>
                    </div>
                    {/* <div style={{background: `url(${props.templateimage}) no-repeat`, height: '114px', width: '92px'}} ></div> */}
                    {/* </div> */}
                    <span
                      style={{ margin: "auto", textAlign: "center" }}
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.definedText +
                            " " +
                            styles.selectedTemplateText
                          : styles.definedText
                      }
                      // onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}
                    >
                      {props.templatename}
                    </span>
                  </Col>
                );
              })}
          </div>
        </>
      );
    default:
      return null;
  }
}

const [leftNavHeiht_in , setLeftNavHeight_in]=useState(0);

useEffect(()=>{
  const topPos= document.querySelector("#templateOptionsTypeBody_span_createPageTemplate")?.getBoundingClientRect()?.top;
  const bottomPos= document.querySelector("#backdropFooter_addPages_Row")?.getBoundingClientRect().top;
  const height = bottomPos - topPos;

  setLeftNavHeight_in(height);
})


  return (
    <div>
      <Backdrop className={classes.backdrop} open={open} key={open}>
      <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} className={styles.backdropDiv} id="createPageTemplate">
        <Row className={styles.backdropHeader}>
            {
              props.componentFor==='subform'?
              t('Create Subform')
              :
              props.isTemplate !== true ? t('Create Page') : t('Page Template')
            }
        </Row>
        <Row className={styles.backdropBody}>
          {props.isTemplate ? null : <Row className={styles.pageTitleRow}>
                <Col className={styles.pageTitleCol1} onClick={()=>setEditingToolOption('All')}>
                    <span className={styles.pageTitleText} style={translationStyles1?{marginLeft:"10px"}:{marginRight:"10px"}}>{t('Page Title')}<span style={{color:"red"}}>*</span></span>
                    <input aria-label={"Page Title"}  type='text' maxLength={50} className={styles.pageTitleInput} onChange={(e)=>handlePageTitle(e)} value={title}/>
                </Col>
                {
                  props.componentFor==='subform'?'':
                  <Col className={styles.pageTitleCol2} >
                      <input aria-label={"Set Home"} type='checkbox' className={styles.pageTitleCheckbox}  onClick={(e)=>handlePageCheckbox(e)} style={{height:"14px", width:"14px", marginRight:"5px !important"}} />
                      <span className={styles.pageTitleText} style={translationStyles1?{marginRight:"10px"}:{marginLeft:"10px"}}>{t('Make this page as the Home Page of your Application')}</span>
                  </Col>
                }
            </Row>}
            
            
            <Row className={styles.backdropTemplateRow}>
                <Col className={styles.backdropLeftBody}>
                   <Col 
                      className={
                        props.isTemplate ? 
                          styles.definingOptionColForTemplate :
                          styles.definingOptionCol
                      }
                      style={{textAlign:"center"}}
                    >
                        <span tabIndex={0} style={{cursor:"pointer", height:"auto" }} className={templateType === 'System defined' ? styles.selectedDefinedText  + ' ' + styles.definedText : 
                        styles.definedText} onClick={()=>setTemplateType('System defined')}>
                          {t("System defined")}</span>
                        <span tabIndex={0} style={{cursor:"pointer", height:"auto" }} className={templateType === 'User defined' ? styles.selectedDefinedText  + ' ' + styles.definedText :
                         styles.definedText} onClick={()=>setTemplateType('User defined')}>
                          {t("User defined")}</span>
                    </Col>
                    <Col style={{maxHeight : `${leftNavHeiht_in - 20}px`, height: `${leftNavHeiht_in - 20}px` }} className={styles.templateOptionsTypeBody} id="templateOptionsTypeBody_span_createPageTemplate" >
                    {templateType === 'System defined' ? 
                      collapsibleItems.map((item)=>{
                        return item;
                      })
                    : templateType === 'User defined' ? 
                    collapsibleItems2.map((item)=>{
                      return item;
                    })
                    :
                    <></>
                    } 
                        {/* <CreatePageTemplate label={'Image On Left'} src={require("../../../Icons/imageOnLeft.svg")}/> */}
                    </Col>
                </Col>
                <Col className={styles.backdropRightBody}>
                  {props.isTemplate ? <Col className={styles.createBlankForTemplate}> </Col> :  <Col className={styles.createBlankCol} style={translationStyles1?{paddingLeft:"20px"}:null} onClick={()=>setEditingToolOption('All')}>
                        {
                          props.componentFor==='subform'?
                          <Button disableFocusRipple
                          disableRipple
                          tabIndex={0}
                          className={`${title==="" ? styles.blankButtonDisabled :styles.blankButton} formBuilder-MuiButton-outlined`} disabled={title=="" ? true : false} onClick={()=>addNewSubForm()}> {t('Create From Blank')} </Button>
                          :
                          <Button disableFocusRipple
                          disableRipple
                          tabIndex={0}
                          className={`${title==="" ? styles.blankButtonDisabled :styles.blankButton} formBuilder-MuiButton-outlined`} disabled={title=="" ? true : false} onClick={()=>createBlankPage()}> {t('Create From Blank')} </Button>
                        }
                        
                    </Col>}
                   
                    <Col 
                    style={{maxHeight : `${leftNavHeiht_in - 40}px`, height: `${leftNavHeiht_in - 40}px` }}
                    className={[styles.backdropRightTemplateBody, templateForm && Object.keys(templateForm).length ===0 ? 
                    styles.backdropRightTemplateLoadingBody : null].join(' ')} key= {selectedTemplateOption} >
                    {
                      <>
                      {
                       
                        /* <div 
                        style={{
                          // backgroundSize: "cover", 
                          backgroundImage: `url(${imageFile})`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "100% 100%", 
                          // background: `url(${imageFile}) cover`,
                          height: '369px', 
                          width: '654px'
                        }} 
                          ></div>  */
                          showLoader === true ? 
                          <CircularProgress />
                          :
                          imageFile && <img src={`${imageFile}`} style={{ height:"auto" , width :"100%", margin:"auto" }} alt='Img Icon' />
                          }
                      
                        </>
                    }
                    
                    </Col>
                </Col>
            </Row>
        </Row>
        <Row className={styles.backdropFooter} id="backdropFooter_addPages_Row" style={translationStyles1?{paddingLeft:"10px"}:null}>
            <Button disableFocusRipple
                        disableRipple
                        tabIndex={0} className={`${styles.cancelButton} formBuilder-MuiButton-outlined`}
                         onClick={()=>{props.handleClose()}}> {t('Cancel')} </Button>
            <Button disableFocusRipple
                        disableRipple
                        tabIndex={0}
            className={`${(title ==="" || !selectedTemplateOption ) ? styles.saveButtonDisabled : styles.saveButton} formBuilder-MuiButton-outlined`} onClick={()=>handleTemplate()} disabled={(title ==="" || !selectedTemplateOption  )? true : false} > {t('Create')}</Button> 
            
        </Row>
      </div>
      </Backdrop>
      
    </div>
  );
}